import { DatePipe } from '@angular/common';
import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Observable, OperatorFunction, debounceTime, distinctUntilChanged, map } from 'rxjs';
import { BodyCumulo } from 'src/app/interfaces/body_cumulo';
import { BodyDatosInmueble } from 'src/app/interfaces/bodyDatosInmueble';
import { Home } from 'src/app/interfaces/home';
import { HomeResponse } from 'src/app/interfaces/home-response';
import { ResponseInmueble } from 'src/app/interfaces/response_inmueble';
import { DatosGeneralesModel } from 'src/app/models/datosGenenrales';
import { Locations } from 'src/app/models/locations';
import { CiudadesService } from 'src/app/services/cuidades/ciudades.service';
import { DataLayerService } from 'src/app/services/dataLeyer/data-leyer.service';
import { OrquestadorService } from 'src/app/services/orquestador/orquestador.service';
import { environment } from 'src/environments/environment';
import { CUMULO, DATOS_INQUILINO, TIEMPO_INACTIVO } from 'src/app/routes.constants';
import { LoaderService } from '@app/services/general/loader.service';

@Component({
  selector: 'app-info-inmueble',
  standalone: false,
  templateUrl: './info-inmueble.component.html',
  styleUrl: './info-inmueble.component.scss'
})

export class InfoInmuebleComponent implements OnInit {

  @ViewChild('ciudad') ciudad!: ElementRef;
  @ViewChild('direccion') direccion!: ElementRef;
  @ViewChild('matricula') motriula!: ElementRef;
  @ViewChild('flexCheckAutoriza') flexCheckAutoriza!: ElementRef;

  // Tiempo local de renovación 
  localTimer = environment.LOCAL_TIMER;
  // Cuanta las veces que es invocado el servicio de refrescado de token
  countRefresh = 0;
  // Verifica si hay actividad
  isActivity = false;
  // Intervalo para detectar movimiento del cursor
  isMouseMove: any;
  checador: any;
  saliendo: boolean = false;
  parametro: string = '';
  leadId: string = '';
  departamento: string[] = [];
  codAsesor: string = '';
  responseInmueble!: ResponseInmueble
  IdBitacora: string = '';

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(e: MouseEvent) {
    let posicionX, posicionY, nuevaPosicionY, nuevaPosicionX;
    this.isActivity = true;
    nuevaPosicionX = e.clientX;
    nuevaPosicionY = e.clientY;

    if (this.isActivity && (nuevaPosicionX !== posicionX || nuevaPosicionY !== posicionY)) {
      clearTimeout(this.checador);
      this.checador = setTimeout(() => {
        ;
        if (this.saliendo == false) {
          this.isActivity = false;
          this.saliendo = true;
          clearInterval(this.isMouseMove);
          clearTimeout(this.checador);

          this.datosGenerales.Inmueble.ciudad = this.ciudadSeleccionada;
          this.datosGenerales.Inmueble.direccion = this.formulario.get("direccion")?.value;
          this.datosGenerales.Inmueble.maticula = this.formulario.get("matricula")?.value;
          this.parametro = JSON.stringify(this.datosGenerales);

          this.router.navigate([TIEMPO_INACTIVO, { codigoAsesor: this.codAsesor, idLead: this.leadId, porcPll: '35', msnPll: 'Tiempo inactivo_datos matricula', infoViaje: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
        }
      }, this.localTimer);
    }

    posicionX = e.clientX;
    posicionY = e.clientY;
  }

  public datosGenerales: DatosGeneralesModel = {
    Cliente: {
      cedulaCliente: '',
      celularCliente: '',
      nombreCliente: '',
      tipoIdentificacion: ''
    },
    InfoArrendamiento: {
      tipoPropiedad: '',
      ubicacion: '',
      valorAdministracion: 0,
      valorArriendo: 0,
      fechaContrato: '',
      duracionContrato: '',
      ServiciosPublicos: false,
      PaquetesAsistencia: false
    },
    Propietario: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      paisNacimiento: '',
      tipoIdentificacion: '',
      numeroIdentificacion: '',
      fechaExpedicion: '',
      correo: ''
    },
    PlanSeleccionado: {
      plan: '',
      valorPlan: 0
    },
    Inmueble: {
      ciudad: '',
      direccion: '',
      maticula: ''
    },
    Inquilino: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      numCelular: '',
      correo: '',
      paisNacimento: '',
      fechaNacimento: '',
      tipoidentificacion: '',
      documentoIdentidad: '',
      fechaExpedicion: '',
      ciudad: '',
      direccion: ''
    },
    ResponseRiesgoConsultable: [
      {
        esRiesgo: false,
        tipoValidacion: '',
        mensajeValidacion: '',
        idRegistroValidacion: ''
      }
    ]
  };

  datosEnvio: BodyDatosInmueble = {
    SessionId: '',
    productFamily: '',
    leadId: '',
    screenPercentage: '',
    asesorCode: '',
    bitacoraId: '',
    getCumulo: false,
    productsConfigurationData: {
      ProductCode: '',
      PolicyHolder: {
        LastName: '',
        CountryOfBirth: '',
        DocumentNumber: '',
        DocumentType: '',
        ExpeditionDate: '',
        FirstName: '',
        Mail: '',
        MobilePhone: '',
        PersonalDataAuthorization: false,
        PersonalDataLastUpdated: '',
        PersonalDataVersion: '',
        SecondLastName: '',
        SecondName: ''
      },
      Property: {
        AdministrationValue: 0,
        ContractStartDate: '',
        Department: '',
        RentalFee: 0,
        TemporaryContracted: '',
        UseProperty: '',
        CityProperty: '',
        PropertyAddress: '',
        RealEstateLicensePlate: '',
        // new atrivutes for Property
        DepartmentCode: '',
        Code: '',
        CityCode: ''
      },
      Tenant: {
        DocumentNumber: '',
        DocumentType: ''
      }
    }
  };

  bodyCumulo: BodyCumulo = {
    getCumulo: false,
    productsConfigurationData: {
      Property: {
        RealEstateLicensePlate: ''
      }
    }
  };

  ngSelectTI: string = 'C';
  json: string = '';
  jsonFinal: string = '';
  mensajeAlerta: string = '';
  swAlerta: boolean = false;
  id: any;
  states: string[] = [];
  locations: Locations[] = []
  ciudadSeleccionada: string = '';
  sessionId: string = '';
  bodyEnvio: Home = { getInitialData: false };
  homeRespose!: HomeResponse;

  formulario: FormGroup = new FormGroup(
    {
      ciudad: new FormControl('', [Validators.required, Validators.maxLength(80)]),
      direccion: new FormControl('', [Validators.required]),
      matricula: new FormControl('', [Validators.required]),
      flexCheckAutoriza: new FormControl('', [Validators.required])
    }
  );

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _dataLayerService: DataLayerService,
    private orquestadorService: OrquestadorService,
    private loaderService: LoaderService
  ) { }

  getLocalStorage(): number {
    return Number(localStorage.getItem('session_id'))
  }

  @Input() infoCliente?: string;
  @Input() idLead?: string;
  @Input() codigoAsesor?: string = '';
  @Input() bitacoraId: string = '';

  ngOnInit(): void {
    this.loaderService.show()
    this.sessionId = this.getLocalStorage().toString();

    this.route.paramMap.subscribe((params: ParamMap) => {
      this.leadId = params.getAll('idLead')[0];
      const resultado = params.get('infoCliente');
      this.codAsesor = params.getAll('codigoAsesor')[0];
      this.IdBitacora = params.getAll('bitacoraId')[0];

      if (resultado !== null) {
        this.json = resultado;
        this.jsonFinal = atob(this.json);
        this.datosGenerales = JSON.parse(this.jsonFinal);
        this.parametro = JSON.stringify(this.datosGenerales);
        this.ciudadSeleccionada = this.datosGenerales.Inmueble.ciudad.split(' - ')[0];
      }
      else {
        const paramInfoCliente = this.infoCliente;
        const paramIdLead = this.idLead;
        this.leadId = paramIdLead !== undefined ? paramIdLead : '';
        this.codAsesor = this.codigoAsesor !== undefined ? this.codigoAsesor : '';
        this.IdBitacora = this.bitacoraId !== undefined ? this.bitacoraId : '';

        if (paramInfoCliente !== undefined) {
          this.json = paramInfoCliente;
          this.jsonFinal = atob(this.json);
          this.datosGenerales = JSON.parse(this.jsonFinal);
          this.parametro = JSON.stringify(this.datosGenerales);

          this.formulario.get("ciudad")?.setValue(this.datosGenerales.Inmueble.ciudad);
          this.ciudadSeleccionada = this.datosGenerales.Inmueble.ciudad;
          this.formulario.get("direccion")?.setValue(this.datosGenerales.Inmueble.direccion);
          this.formulario.get("matricula")?.setValue(this.datosGenerales.Inmueble.maticula);
        }
      }
    });

    this.bodyEnvio.getInitialData = true;
    this.orquestadorService.postOrquestadorIntermedia(this.bodyEnvio).
      subscribe(
        (data) => {
          if (data !== undefined) {
            this.homeRespose = data;
            const vart = JSON.parse(JSON.stringify(this.homeRespose.data));
            this.locations = vart.locations

            this.locations.forEach(itemCiudad => {
              if (itemCiudad.SURACiudadDepartamento__c !== 'undefined') {
                this.states.push(itemCiudad.SURACiudad__c)
              }
            });
          }
        }
      );
     
    this.loaderService.hide()
      
  }

  ngOnDestroy() {
    this.saliendo = true;
    clearInterval(this.isMouseMove);
    clearTimeout(this.checador);

    if (this.checador) {
      clearInterval(this.checador);
    }
  }

  get ValidaCiudad() {
    if (this.datosGenerales.InfoArrendamiento.ubicacion !== '') {
      if (this.datosGenerales.InfoArrendamiento.ubicacion.includes(' - ')) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      return false;
    }
  }

  search: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term.length < 2 ? [] : this.states.filter((v) =>
          v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
      ),
    );

  get ciudadNoValido() {
    if (this.formulario.get("ciudad")?.value === ''
      && this.formulario.get("ciudad")?.touched) {
      return true;
    }
    return false;
  }

  valCiudad = false;
  valCiudad2 = true;
  validacionCiudad() {
    if (this.formulario.get("ciudad")?.value === '') {
      this.valCiudad = !this.valCiudad;
      this.valCiudad2 = !this.valCiudad2;
    }
    else if (this.states.filter(ciu => ciu === this.formulario.get("ciudad")?.value).length === 0) {
      this.valCiudad = !this.valCiudad;
      this.valCiudad2 = !this.valCiudad2;
    }
    else {
      this.locations.forEach(selecCiudad => {
        if (selecCiudad.SURACiudadDepartamento__c === this.formulario.get("ciudad")?.value) {
          this.ciudadSeleccionada === '' ? this.ciudadSeleccionada = selecCiudad.SURACiudad__c : this.ciudadSeleccionada;
        }
      });

      this.valCiudad = false;
      this.valCiudad2 = true;
    }
  }


  get direccionNoValido() {
    return this.formulario.get("direccion")?.invalid
      && this.formulario.get("direccion")?.touched;
  }

  valDireccion = false;
  valDireccion2 = true;
  validacionDireccion() {
    if (this.formulario.get("direccion")?.value === '') {
      this.valDireccion = !this.valDireccion;
      this.valDireccion2 = !this.valDireccion2;
    } else {
      this.valDireccion = false;
      this.valDireccion2 = true;
    }
  }

  get matriculaNoValida() {
    return this.formulario.get("matricula")?.invalid
      && this.formulario.get("matricula")?.touched;
  }

  valMatricula = false;
  valMatricula2 = true;
  validacionMatricula() {
    if (this.formulario.get("matricula")?.value === '') {
      this.valMatricula = !this.valMatricula;
      this.valMatricula2 = !this.valMatricula2;
    } else {
      this.valMatricula = false;
      this.valMatricula2 = true;
    }
  }

  get formularioNoValido() {
    return this.formulario.invalid
  }

  continuar() {
    this.datosGenerales.Inmueble.ciudad = this.ciudadSeleccionada;
    this.datosGenerales.Inmueble.direccion = this.formulario.get("direccion")?.value;
    this.datosGenerales.Inmueble.maticula = this.formulario.get("matricula")?.value;
    this.parametro = JSON.stringify(this.datosGenerales);

    this._dataLayerService.logDatosInmueble('ecommerce_step_6', 'Arrendamiento', 'Datos inmuebles',
      this.sessionId, this.datosGenerales.InfoArrendamiento.valorArriendo.toString(),
      this.datosGenerales.InfoArrendamiento.valorAdministracion.toString(),
      this.datosGenerales.InfoArrendamiento.tipoPropiedad,
      this.datosGenerales.InfoArrendamiento.ubicacion, this.datosGenerales.InfoArrendamiento.ubicacion,
      this.datosGenerales.InfoArrendamiento.duracionContrato,
      this.datosGenerales.InfoArrendamiento.fechaContrato, this.datosGenerales.PlanSeleccionado.plan,
      this.datosGenerales.PlanSeleccionado.valorPlan.toString(), this.datosGenerales.InfoArrendamiento.ServiciosPublicos ? 'true' : 'false',
      this.datosGenerales.InfoArrendamiento.PaquetesAsistencia ? 'true' : 'false', this.datosGenerales.Inmueble.maticula);

    this.GuardarDataLayer();
  }

  private GuardarDataLayer() {
    const datepipe: DatePipe = new DatePipe('en-US')
    let formattedDate = datepipe.transform(Date.now(), 'dd/MM/YYYY');

    this.datosEnvio.SessionId = this.sessionId;
    this.datosEnvio.productFamily = 'Arrendamientos';
    this.datosEnvio.leadId = this.leadId;
    this.datosEnvio.screenPercentage = '35';

    if (this.codAsesor === 'undefined') {
      this.codAsesor = '';
      this.datosEnvio.asesorCode = this.codAsesor;
    }

    if (this.codAsesor !== '') {
      this.datosEnvio.asesorCode = this.codAsesor;
    }
    else {
      this.datosEnvio.asesorCode = this.codAsesor;
    }

    this.datosEnvio.bitacoraId = this.IdBitacora;
    this.datosEnvio.getCumulo = true;

    this.datosEnvio.productsConfigurationData.ProductCode = this.datosGenerales.PlanSeleccionado.plan
    this.datosEnvio.productsConfigurationData.PolicyHolder.LastName = this.datosGenerales.Propietario.primerApellido;
    this.datosEnvio.productsConfigurationData.PolicyHolder.MobilePhone = this.datosGenerales.Cliente.celularCliente.toString();
    this.datosEnvio.productsConfigurationData.PolicyHolder.PersonalDataAuthorization = true;
    this.datosEnvio.productsConfigurationData.PolicyHolder.PersonalDataVersion = this.datosEnvio.productsConfigurationData.PolicyHolder.PersonalDataVersion == '' ? (formattedDate === null ? '' : formattedDate) : this.datosEnvio.productsConfigurationData.PolicyHolder.PersonalDataVersion;
    this.datosEnvio.productsConfigurationData.PolicyHolder.PersonalDataLastUpdated = formattedDate === null ? '' : formattedDate;
    this.datosEnvio.productsConfigurationData.PolicyHolder.FirstName = this.datosGenerales.Propietario.primerNombre;
    this.datosEnvio.productsConfigurationData.PolicyHolder.Mail = this.datosGenerales.Propietario.correo;
    this.datosEnvio.productsConfigurationData.PolicyHolder.ExpeditionDate = this.datosGenerales.Propietario.fechaExpedicion;
    this.datosEnvio.productsConfigurationData.PolicyHolder.DocumentNumber = this.datosGenerales.Propietario.numeroIdentificacion.toString();
    this.datosEnvio.productsConfigurationData.PolicyHolder.DocumentType = this.datosGenerales.Cliente.tipoIdentificacion;
    this.datosEnvio.productsConfigurationData.PolicyHolder.CountryOfBirth = this.datosGenerales.Propietario.paisNacimiento;
    this.datosEnvio.productsConfigurationData.PolicyHolder.SecondLastName = this.datosGenerales.Propietario.segundoApellido;
    this.datosEnvio.productsConfigurationData.PolicyHolder.SecondName = this.datosGenerales.Propietario.segundoNombre;
    this.datosEnvio.productsConfigurationData.Tenant.DocumentNumber = this.datosGenerales.Cliente.cedulaCliente.toString();
    this.datosEnvio.productsConfigurationData.Tenant.DocumentType = this.datosGenerales.Cliente.tipoIdentificacion;
    this.datosEnvio.productsConfigurationData.Property.AdministrationValue = this.datosGenerales.InfoArrendamiento.valorAdministracion;
    this.datosEnvio.productsConfigurationData.Property.RentalFee = this.datosGenerales.InfoArrendamiento.valorArriendo;
    this.datosEnvio.productsConfigurationData.Property.Department = this.datosGenerales.InfoArrendamiento.ubicacion;
    this.datosEnvio.productsConfigurationData.Property.UseProperty = this.datosGenerales.InfoArrendamiento.tipoPropiedad;
    this.datosEnvio.productsConfigurationData.Property.ContractStartDate = this.datosGenerales.InfoArrendamiento.fechaContrato;
    this.datosEnvio.productsConfigurationData.Property.TemporaryContracted = this.datosGenerales.InfoArrendamiento.duracionContrato;
    this.datosEnvio.productsConfigurationData.Property.CityProperty = this.ciudadSeleccionada;
    this.datosEnvio.productsConfigurationData.Property.PropertyAddress = this.datosGenerales.Inmueble.direccion;
    this.datosEnvio.productsConfigurationData.Property.RealEstateLicensePlate = this.datosGenerales.Inmueble.maticula;
    this.datosEnvio.productsConfigurationData.Property.Code = this.datosGenerales.InfoArrendamiento.Code;
    this.datosEnvio.productsConfigurationData.Property.CityCode = this.datosGenerales.InfoArrendamiento.CityCode;
    this.datosEnvio.productsConfigurationData.Property.DepartmentCode = this.datosGenerales.InfoArrendamiento.DepartmentCode;


    this.orquestadorService.postOrquestadorDatosInmueble(this.datosEnvio).
      subscribe(
        (data) => {
          this.responseInmueble = data;
          if (this.responseInmueble.data.policies.length > 0) {
            //this.router.navigate(['NoSARLAFT', { porcPll: '35', msnPll: 'Politicas de cumulo.', codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
            this.router.navigate([CUMULO, { porcPll: '35', msnPll: 'Politicas de cumulo.', codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
          }
          else {
            this.router.navigate([DATOS_INQUILINO, { codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
          }
        }
      );
  }

}


